import SwiperCore, { Navigation } from 'swiper/core';
import { UserInfo } from '../../user/userInfo.js';
import { createShopItemsList, createShopSliderItem } from './shop-slider-item';
import { checkItemRestrictions } from './utilities';

export async function initShopSliders() {
  const { md5 } = await import('../../tools/md5.js'),
    { getJSON } = await import('../../tools/basic-functions.js');

  let jsonURL = '/' + _CMS_LANGUAGE + '/json/shop-items.json',
    allShopItems = await getJSON(jsonURL),
    shopSlidersList = document.querySelectorAll('.energyShop-products'),
    userProfile = _CMS_USER_PROFILE ?? [];

  const userInfoInstance = new UserInfo();
  const isLogged = await userInfoInstance.isLoggedAsync();

  if (isLogged && Array.isArray(userProfile)) {
    userProfile.push(md5('s-active'));
    userProfile.push(md5('d-' + _CMS_USER_NO_DEP));
  } else {
    userProfile = md5('s-inactive');
  }

  for (const shopSlider of shopSlidersList) {
    initShopSlider(shopSlider, allShopItems.items, userProfile);
  }

  if (_CMS_USER_NO_DEP !== '0') {
    const energyShopBanner = document.querySelector('.energyShop-banner');
    if (!energyShopBanner) {
      return;
    }

    energyShopBanner.classList.remove('d-none');
  }
}

async function initShopSlider(shopSlider, allShopItems, userProfile) {
  let category = shopSlider.getAttribute('data-category'),
    shopItemsList = createShopItemsList(category, allShopItems);
  if (shopItemsList) {
    for (const shopItem of shopItemsList) {
      if (!checkItemRestrictions(shopItem, userProfile)) {
        continue;
      }

      const shopSliderItem = await createShopSliderItem(shopItem);
      shopSlider.querySelector('.panels-body').appendChild(shopSliderItem);
    }

    if (shopItemsList.length == 0) {
      shopSlider.remove();
      document.querySelector('.energyShop-category .panel[data-category="' + category + '"]')?.remove();
      return;
    }

    if (_CMS_MOBILE) {
      return;
    }

    SwiperCore.use([Navigation]);
    new SwiperCore(shopSlider, {
      slidesPerView: 4,
      spaceBetween: 10,
      speed: 300,
      navigation: {
        nextEl: '.btn-next',
        prevEl: '.btn-previous'
      }
    });
  }
}
